import React, { useState, DetailedHTMLProps, InputHTMLAttributes, ReactNode, forwardRef } from 'react';

import clsx from 'clsx';

import useRandomId from 'hooks/randomIdFallback';

import styles from './PasswordInput.module.scss';

type HTMLInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface PasswordInputProps extends Omit<HTMLInputProps, 'ref'> {
  id?: string;
  labelTitle: string;
  errorMessage?: string;
  topRightElement?: ReactNode;
  containerClassName?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (
    { id: providedId, labelTitle, onChange, errorMessage, value, topRightElement, containerClassName, ...inputProps },
    ref,
  ) => {
    const id = useRandomId(providedId);
    const [isVisible, setVisible] = useState(false);
    const [isFocused, setFocus] = useState(false);
    const toggleFocusInput = () => {
      setFocus(!isFocused);
    };
    const toggleVisibility = () => {
      setVisible(!isVisible);
    };

    return (
      <div className={clsx(styles.inputContainer, containerClassName)}>
        <div className={styles.labelWithLink}>
          <label htmlFor={id} className={styles.label}>
            {labelTitle}
          </label>
          {topRightElement}
        </div>
        <label
          className={clsx(
            styles.inputContainer__input,
            isFocused && styles.inputFocus,
            errorMessage && styles.inputError,
          )}
        >
          <input
            type={isVisible ? 'text' : 'password'}
            id={id}
            value={value}
            onFocus={toggleFocusInput}
            onBlur={toggleFocusInput}
            onChange={onChange}
            autoComplete="none"
            className={styles.input}
            ref={ref}
            {...inputProps}
          />
          <button
            type="button"
            tabIndex={-1}
            className={isVisible ? styles.hideButton : styles.showButton}
            onClick={toggleVisibility}
          >
            {' '}
          </button>
        </label>
        {errorMessage && <p className={styles.inputContainer__error}>{errorMessage}</p>}
      </div>
    );
  },
);

export default PasswordInput;
